'use client';
import React from 'react';
import addDays from 'date-fns/addDays';

import Layout from '../lib/components/Layout';
import CalendarService from '../lib/services/CalendarService';
import ColumnsDefinition from './ColumnsDef';
import { formatRequestDate, injectLogos } from '../lib/utils';
import { fetchDividends } from './Services';

import { ICalendarProps, IDateRange } from '../lib/interfaces';
import { Dividend } from '@benzinga/calendar-manager';

export const DividendsCalendarColumnsDef = ColumnsDefinition;
export const fetchDividendsData = fetchDividends;

export const DividendsCalendar: React.FC<ICalendarProps> = ({
  calendar,
  calendarData,
  calendarType,
  hasStockTableStyling,
  height,
  hiddenColumns,
  hideFilters,
  initialData,
  initialDateRange,
  initialTicker,
  leftSlot,
  onReady,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [tableData, setTableData] = React.useState<Dividend[]>(initialData || []);
  let dateRange: IDateRange;

  if (initialDateRange) {
    dateRange = initialDateRange;
  } else {
    dateRange = {
      date_from: formatRequestDate(new Date()),
      date_to: formatRequestDate(addDays(new Date(), 7)),
    };
  }

  React.useEffect(() => {
    if (calendarData?.serverSide) {
      setTableData(initialData);
    }
  }, [initialData, calendarData]);

  function onTableReady() {
    if (initialData) {
      setTableData(initialData);
    } else {
      const params = {
        'parameters[date_from]': dateRange.date_from,
        'parameters[date_sort]': 'ex',
        'parameters[date_to]': dateRange.date_to,
      };
      if (initialTicker) {
        params['parameters[tickers]'] = initialTicker;
      }
      fetchData(params);
    }

    if (onReady) {
      setTimeout(() => onReady());
    }
  }

  function fetchData(filterParams: any) {
    const query = {
      ...filterParams,
      pagesize: 1000,
    };

    setLoading(true);

    const Calendar = new CalendarService();

    Calendar.getDividends(query)
      .then(({ data }: any) => {
        const items: any = [];
        if (Array.isArray(data.dividends) && data.dividends.length) {
          return injectLogos(data.dividends);
        }
        return items;
      })
      .then((items: any) => {
        setTableData(items);
        setLoading(false);
      });
  }

  return (
    <Layout
      calendar={calendar}
      calendarData={calendarData}
      calendarType={calendarType}
      columnDefs={ColumnsDefinition}
      defaultAdditionalParams={{ date_sort: 'ex' }}
      enableSearch
      hasStockTableStyling={hasStockTableStyling}
      height={height}
      hiddenColumns={hiddenColumns}
      hideFilters={hideFilters}
      initialDateRange={dateRange}
      leftSlot={leftSlot}
      onFilterChanged={fetchData}
      onTableReady={onTableReady}
      tableData={tableData}
      tableLoading={loading}
      ticker={initialTicker}
    />
  );
};
